var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tangram-goods",style:(_vm.module.containerStyle),attrs:{"data-tangram-module-id":_vm.module.id}},[(_vm.module.data.tabs.length && _vm.module.isGroup)?_c('ul',{staticClass:"tabs",style:({
      top: _vm.stickyTop,
      backgroundColor: _vm.tabStyle.titleBgColor
    })},_vm._l((_vm.module.data.tabs),function(tab,index){return _c('li',{key:index,class:{
        current: index === _vm.currentIndex
      },on:{"click":function($event){return _vm.switchTab(index)}}},[_c('p',{style:({
          color:
            index === _vm.currentIndex
              ? _vm.tabStyle.selectedTitleColor
              : _vm.tabStyle.unselectTitleColor,
          backgroundColor:
            index === _vm.currentIndex ? _vm.tabStyle.selectedColor : ''
        })},[_vm._v(" "+_vm._s(tab.name)+" ")])])}),0):_vm._e(),(_vm.module.data.tabs.length && _vm.module.isBillionGoodsGroup)?_c('ul',{staticClass:"tabs billion-tabs",style:({
      top: _vm.stickyTop
    })},_vm._l((_vm.module.data.tabs),function(tab,index){return _c('li',{key:tab.group_id,class:{
        current: index === _vm.currentIndex
      },on:{"click":function($event){return _vm.switchTab(index)}}},[_c('p',{style:(index === _vm.currentIndex ? _vm.module.tabCurrentStyle : {})},[_vm._v(" "+_vm._s(tab.name)+" ")])])}),0):_vm._e(),_vm._l((_vm.module.data.goods[_vm.currentIndex]),function(group,index){return _c('div',{key:index,class:[
      'group',
      {
        'can-scroll': _vm.canScroll,
        'flex-start':
          index === _vm.module.data.goods[_vm.currentIndex].length - 1 &&
          group.length < _vm.module.factor
      }
    ],style:({
      'margin-bottom':
        index === _vm.module.data.goods[_vm.currentIndex].length - 1 && !_vm.isXN
          ? '0'
          : _vm.module.elementMarginCalculated
    })},[_vm._l((group),function(good){return [_c(_vm.componentType,{directives:[{name:"tangram-expose",rawName:"v-tangram-expose",value:(
          Object.assign({}, good.ssu.ssuInfo.tickerInfo, {
            extraTrack: good.ssu.extraTrack
          })
        ),expression:"\n          Object.assign({}, good.ssu.ssuInfo.tickerInfo, {\n            extraTrack: good.ssu.extraTrack\n          })\n        "}],key:good.ssu.ssuInfo.ssuId,tag:"component",style:(index === _vm.module.data.goods[_vm.currentIndex].length - 1 &&
          group.length < _vm.module.factor
            ? Object.assign(good.goodStyle, {
                'margin-right': _vm.module.elementMarginCalculated
              })
            : good.goodStyle),attrs:{"ssu":good.ssu,"sku-index":index,"good-width":good.goodWidth,"type":_vm.module.layoutType}})]})],2)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }